module.exports = __webpack_public_path__ + "fonts/6bbd5cf.ttf";